import { Suspense } from 'react';
import { useState } from 'react';
import Permission from '../../components/Permission/Permission';
import Spinner from '../../components/Spinner/Spinner';
import withForm from '../../hoc/withForm';
import * as constants from '../../constants';
import SectionHeader from '../../components/SectionHeader/SectionHeader';
import { useFranchiseStore } from '../../store/providers/Franchise';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Row, Button } from 'react-bootstrap';
import { useEffect } from 'react';
import _ from 'lodash';
import { breadcrumbAddRoute, breadcrumbRemoveRoute } from '../../store/actions/breadcrumb';
import { navigate } from 'raviger';
import { useAlertStore } from '../../store/providers/Alert';

function IntegrationsForm(props) {
    const dispatch = useDispatch();
    const { franchise } = useSelector(state => ({
        franchise: state.franchise.franchise
    }));

    const { addAlert } = useAlertStore();
    const { getIntegrations, updateIntegrations, data, clearData } = useFranchiseStore();

    const [isMounted, setIsMounted] = useState(false);
    const [isBusy, setIsBusy] = useState(false);
    const [gmailGroupManagerInfo, setGmailGroupManagerInfo] = useState('');

    const pagePermission = constants.PERMISSION_FRANCHISES_COMMISSIONS_TRANSACTIONFEES;
    const [hasPermission, setHasPermission] = useState(false);
    const [canEdit, setCanEdit] = useState(false);

    useEffect(() => {
        if (!hasPermission) { return; }
        if (isMounted) { return; }

        dispatch(breadcrumbAddRoute({ key: 'franchise-Integrations', text: 'Integrations' }));

        getIntegrations({ franchiseId: franchise.id });
        setIsMounted(true);
    }, [isMounted, hasPermission, getIntegrations, dispatch, franchise]);

    useEffect(() => {
        if (!_.isEmpty(data)) {
            if (data.status === 'fail' || data.status === 'error') {
                addAlert({ key: constants.ALERT_SERVER_ERROR, text: <strong>{data.body}</strong>, type: constants.ALERT_TYPE_DANGER });
                clearData();
            }

            if (data.status === 'success' && data.scope === 'integrations') {
                const { gmailGroupManagerInfo } = data.body;
                if (gmailGroupManagerInfo) {
                    try {
                        setGmailGroupManagerInfo(JSON.stringify(JSON.parse(gmailGroupManagerInfo), undefined, 4));
                    } catch {
                        setGmailGroupManagerInfo(gmailGroupManagerInfo);
                    }
                }
            }

            if (data.status === 'success' && data.scope === 'updateintegrations') {
                navigate('/instances');
            }
        }
        setIsBusy(!_.isEmpty(data) && (data.status === 'processing'));
    }, [data]);

    useEffect(() => {
        return () => {
            dispatch(breadcrumbRemoveRoute());
        };
    }, [dispatch]);

    const save = () => {
        const integrationsVm = {
            gmailGroupManagerInfo,
            franchiseId: franchise.id
        };
        updateIntegrations(integrationsVm);
    }

    return (
        <>
            <Permission showDenied={true} pagePermission={pagePermission} hasPermission={hasPermission} setHasPermission={setHasPermission} setCanEdit={setCanEdit} />
            {
                hasPermission && isMounted &&
                <Suspense fallback={<Spinner text="Loading..." />}>
                    {
                        isBusy
                            ? <Spinner text="Loading..." />
                            : <>
                                <SectionHeader title="Gmail Group Manager" />
                                <Row>
                                    <div className="col-md-12">
                                        <textarea className='form-control' rows={5} autoComplete="off" value={gmailGroupManagerInfo || ''}
                                            style={{ height: 'calc(100vh - 400px)' }} onChange={(e) => setGmailGroupManagerInfo(e.target.value)} />
                                    </div>
                                </Row>
                                <div className="form-action-buttons" style={{ marginTop: '15px' }}>
                                    <Button bsStyle="default" className="button-group-margin" disabled={isBusy} onClick={() => navigate('/instances')}>
                                        <i className="fa fa-undo button-icon"></i>
                                        Back
                                    </Button>
                                    <Button bsStyle="danger" variant="danger" type="button" className="button-group-margin" disabled={!canEdit || isBusy} onClick={save}>
                                        <i className="fa fa-save button-icon"></i>
                                        {isBusy ? 'Saving...' : 'Save & Exit'}
                                    </Button>
                                </div>
                            </>
                    }
                </Suspense>
            }
        </>
    )
}

export default withForm(IntegrationsForm);